import {
  Box,
  ImageTextSplitBlock,
  PageSection,
} from '@/src/packages/components';
import { getRoute } from '@/src/packages/utils/routes';
import { PageSectionTitle } from '@/src/packages/components/ui/PageSection/PageSectionTitle';
import { useProductContext } from '@/src/packages/components/pages/Product/ProductContext';
import { paths } from '@/src/packages/routes';
import { pathParams } from '@/src/packages/routes/pathParams.enum';
import { PageSectionSubheading } from '@/src/packages/components/ui/PageSection/PageSectionSubheading';

export const ProductMaterials = () => {
  const {
    productVariant: {
      product: { materials },
    },
  } = useProductContext();

  return (
    <PageSection>
      <PageSectionTitle>Materials</PageSectionTitle>
      <PageSectionSubheading>
        We select all of our materials by applying our fundamental principles;
        is it hardwearing? how is it produced? And how will it look in 10, 20
        years time? Finding the materials that meet our criteria means sampling
        dozens of options until we find the right one.
      </PageSectionSubheading>
      {materials.map((material, i) => {
        return (
          <Box colSpan={{ initial: 12, lg: 12 }} key={i}>
            <ImageTextSplitBlock
              isFlipped={i % 2 === 0}
              imageURL={material.fields.cover.fields.file.url}
              name={material.fields.name}
              description={material.fields.description}
              readMoreHref={getRoute({
                route: paths.MATERIALS_SINGLE,
                params: {
                  [pathParams.MATERIAL_SINGLE]: material.fields.slug,
                },
              })}
            />
          </Box>
        );
      })}
    </PageSection>
  );
};
